import React from "react";
import OrderDetailBody from "./OrderDetailBody";
import { resolveOrderFromItem } from "./orderDetailUtils";

/** Admin inbox detail for an order approval queue item. */
const OrderApprovalDetail = ({ item, format, navigate, detailSection = "all" }) => {
  const order = resolveOrderFromItem(item);
  const rejectReasonOverride =
    item?.status === "rejected" ? item?.reason : undefined;

  return (
    <OrderDetailBody
      order={order}
      format={format}
      rejectReasonOverride={rejectReasonOverride}
      detailSection={detailSection}
      onNavigateToSale={
        navigate
          ? (saleId) => navigate(`/device-sales/edit/${saleId}`)
          : undefined
      }
    />
  );
};

export default OrderApprovalDetail;
